// extracted by mini-css-extract-plugin
module.exports = {"container":"blogindex-module--container--2C1vu layout--module--3QxU_"};